module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/banner-wap-3q.08be84b3.jpg";